module.exports = __webpack_public_path__ + "static/media/suburban_community.e63c0eb4.jpg";